@if (digitalSignage) {
	@if (digitalSignage?.mode === SignageMode.Media) {
		<div style="height: 100%; background-color: black">
			@if (digitalSignageMedia && digitalSignageMedia.mediaType === MediaType.Image) {
				<sim-image-viewer [media]="digitalSignageMedia" />
			}
			@if (digitalSignageMedia && digitalSignageMedia.mediaType === MediaType.Video) {
				<sim-video-viewer [media]="digitalSignageMedia" [isPlaying]="true" [isLooping]="true" />
			}
			@if (digitalSignageMedia?.mediaType === MediaType.Audio) {
				<sim-audio-viewer [media]="digitalSignageMedia" [isPlaying]="true" [isLooping]="true" />
			}
			@if (digitalSignageMedia?.mediaType === MediaType.PDF) {
				<sim-document-viewer [media]="digitalSignageMedia" [enableAutoPlay]="true" [autoPlayInterval]="settings.autoPlayInterval" />
			}
			@if (digitalSignageMedia && digitalSignageMedia.mediaType === MediaType.PowerPoint) {
				<sim-presentation-viewer
					[media]="digitalSignageMedia"
					[autoSize]="true"
					[enableAutoPlay]="true"
					[autoPlayInterval]="settings.autoPlayInterval"
				/>
			}
		</div>
	}
	@if (digitalSignage?.mode === SignageMode.TrainingRoom) {
		<div>
			@if (digitalSignageTrainingRoom?.id) {
				<sim-base-camera-layout
					[cameraLayoutOptionsContainer]="{
						optionType: 'Livestream',
						options: {
							screens: digitalSignageTrainingRoom?.roomLayout?.[digitalSignage.roomLayoutPreset]?.cameras,
							cameraViewMode: CameraViewMode.AllScreens,
							trainingRoomId: digitalSignageTrainingRoom?.id,
							cameraLayoutType: digitalSignageTrainingRoom?.roomLayout?.[digitalSignage.roomLayoutPreset]?.layoutType,
							cameraLayoutOption: digitalSignageTrainingRoom?.roomLayout?.[digitalSignage.roomLayoutPreset]?.layoutOption,
							displayMode: DisplayMode.Auto,
							preferredStream: CameraResolutionType.RecordingWindow,
							preferredFullscreenStream: CameraResolutionType.RecordingWindowFull,
							dragdropEnabled: false,
							enableControl: false,
						},
					}"
				/>
			}
		</div>
	}
}
